module.exports = __webpack_public_path__ + "img/tip2.8860ee6c.png";